import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { OrderSerial } from "models/OrderSerial";
import { toast } from "react-toastify";
import { useAssignOrderSerialMutation } from "app/api/checklists";
import { useChecklistContext } from "context/ChecklistContext";
import { useOrderContext } from "context/OrderContext";

type Props = {
  serial: OrderSerial;
  onClose?: () => void;
};

const AddOrderSerialDialog: React.FC<Props> = ({ serial, onClose }) => {
  const order = useOrderContext();
  const { checklist } = useChecklistContext();
  const [addSerial, { isLoading }] = useAssignOrderSerialMutation();

  const handleAddSerial = async () => {
    addSerial({
      orderId: order.ordernr,
      checklistId: checklist.id,
      id: serial.id,
      serial: serial.serial,
      ip: serial.ip,
      macAddressWired: serial.macAddressWired,
      macAddressWifi: serial.macAddressWifi,
      ethernetPort: serial.ethernetPort,
      theftMarking: serial.theftMarking,
      assetNo: serial.assetNo,
      userName: serial.userName,
      password: serial.password,
      firmware: serial.firmware,
      other: serial.other,
      doa: serial.doa,
    })
      .unwrap()
      .then(() => {
        toast.success("Produkten har lagts till!", {
          autoClose: 3000,
          hideProgressBar: true,
        });

        onClose?.();
      })
      .catch(() => {
        toast.error("Något gick fel när produkten skulle läggas till.", {
          autoClose: 3000,
          hideProgressBar: true,
        });
      });
  };

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>Lägga till produkten på checklistan?</DialogTitle>

      <DialogActions>
        <Button variant="outlined" disabled={isLoading} startIcon={<CloseIcon />} onClick={onClose}>
          Avbryt
        </Button>

        <Button
          variant="contained"
          loading={isLoading}
          startIcon={<AddIcon />}
          onClick={handleAddSerial}
        >
          Lägg till
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddOrderSerialDialog;
